import { GroupModel } from '../../members/models/Groups.model';
import { GroupDTO, GroupRequestDTO } from '../../members/dtos/Group.dto';

export class GroupUtil {
  public static mapToViewModel(dto: GroupDTO): GroupModel {
    return {
      id: dto.id,
      group: dto.group,
      slug: dto.slug,
      members: dto.members ? dto.members : [],
    };
  }

  public static toRequestDTO(model?: GroupModel): GroupRequestDTO {
    return {
      id: model ? model.id : undefined,
      group: model ? model.group : '',
      members: undefined,
    };
  }
}
